/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

import NCJUA_incentive from "../../assets/images/services/NCJUA-incentive.jpg";

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the section headings and intro copy
      sr.reveal("#incentives p, #incentives h1", {
        origin: "left",
        distance: "20px",
        duration: 600,
        interval: 150,
      });

      // reveal each list item
      sr.reveal("#incentives ul li", {
        origin: "left",
        distance: "20px",
        duration: 600,
        interval: 200,
        delay: 300,
      });

      // reveal the image
      sr.reveal("#incentives figure", {
        origin: "bottom",
        distance: "40px",
        duration: 800,
        delay: 500,
      });
    }
  }, []);

  return (
    <div id="incentives" className="bg-white px-6 py-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base/7 text-gray-700">
        <p className="font-chakra_petch_sm text-base/7 font-semibold text-[#D2B48C]">
          INCENTIVES
        </p>
        <h1 className="font-chakra_petch_lg mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          NCJUA Incentives for Fortified Roofs
        </h1>
        <p className="mt-6 text-xl/8">
          In North Carolina, the North Carolina Joint Underwriting Association
          (NCJUA) offers financial assistance to encourage homeowners to fortify
          their roofs:
        </p>
        <div className="mt-10 max-w-2xl">
          <ul role="list" className="mt-8 max-w-xl space-y-8 text-gray-600">
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-[#D2B48C]"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  $5,000 Insurance Deductible Reimbursement
                </strong>{" "}
                - If a homeowner with a FORTIFIED™ Roof files an insurance
                claim, NCJUA will reimburse up to $5,000 toward their
                deductible.
              </span>
            </li>
            <li className="flex gap-x-3">
              <CheckCircleIcon
                aria-hidden="true"
                className="mt-1 size-5 flex-none text-[#D2B48C]"
              />
              <span>
                <strong className="font-semibold text-gray-900">
                  $10,000 Grant for Roof Upgrades
                </strong>{" "}
                - Homeowners may also qualify for a $10,000 grant from NCJUA to
                help cover the costs of upgrading to a FORTIFIED™ Roof, making
                it more affordable to invest in long-term protection.
              </span>
            </li>
          </ul>
          <p className="mt-8">
            By taking advantage of the FORTIFIED™ Roof Program and available
            financial incentives, homeowners can increase their home's
            resilience while reducing long-term repair costs and insurance
            expenses.
          </p>
        </div>
        <figure className="mt-16">
          <img
            alt=""
            src={NCJUA_incentive}
            className="block mx-auto mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10"
          />
        </figure>
      </div>
    </div>
  );
}
